export const wireMaterials = [
  { value: 'copper', label: 'نحاس (Copper)', resistivity: 0.0175 },
  { value: 'aluminum', label: 'ألمنيوم (Aluminum)', resistivity: 0.0283 }
];

export const insulationTypes = [
  { value: 'pvc', label: 'PVC', maxTemp: 70 },
  { value: 'xlpe', label: 'XLPE', maxTemp: 90 },
  { value: 'rubber', label: 'Rubber', maxTemp: 60 },
  { value: 'silicone', label: 'Silicone', maxTemp: 180 }
];

export const standardWireSizes = [
  1.5, 2.5, 4, 6, 10, 16, 25, 35, 50, 70, 95, 120, 150, 185, 240, 300, 400, 500
];